import { app } from "../serviceLMS"
import { EDIT_COURSE_CONTENT } from "../URLs";

export const fetchAllCourses = async (
  page = 0,
  size = 10,
  sortBy = "createdAt",
  sortDir = "desc",
  search = "",
  active = true
) => {
  try {
    const response = await app.get("course/api/client-api/course", {
      params: { page, size, sortBy, sortDir, search: search || undefined, active },
    });
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw error;
  }
};


export async function deleteCourse(courseId) {
  try {
    const id = typeof courseId === "object" ? courseId.courseId : courseId;
    console.log("Resolved courseId:", id);

    if (id === undefined || id === null) {
      throw new Error("Course ID is required for deletion");
    }

    const response = await app.delete(`course/api/client-api/course/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Course deletion failed");
  }
}

export async function updateCourse(courseId, updatedData) {
  try {
    const response = await app.put(`course/api/client-api/course/${courseId}`, updatedData);
    return response.data.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Course update failed");
  }
}

export async function createCourse(courseData) {
  try {
    const response = await app.post("course/api/client-api/course", courseData);
    return response.data.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Course creation failed");
  }
}

export async function fetchCourseById(courseId) {
  try {
    const response = await app.get(`course/api/client-api/course/${courseId}`);
    console.log(response.data.data);
    return response.data.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Course not found!");
  }
}

export async function fetchCourseContentByCourseId(courseId, queryParams = {}) {
  try {
    const response = await app.get(
      `course/api/client-api/user-progress/course/${courseId}/contents`,
      {
        params: {
          page: queryParams.page ?? 0,
          size: queryParams.size ?? 10,
          searchText: queryParams.searchText || "", 
          sortDir: queryParams.sortDir || "asc",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Course content not found!"
    );
  }
}

export async function deleteCourseContent(id) {
  try {
    const response = await app.delete(`course/api/client-api/course-content/${id}`);
    return response.data.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete course content"
    );
  }
}

export async function updateCourseContent(id, updatedData) {
  try {
    const response = await app.patch(`${EDIT_COURSE_CONTENT}${id}`, updatedData,
      {
      headers: {
        "Content-Type": undefined,
      },
    }
  );
    return response.data.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update course content"
    );
  }
}

export async function createCourseContent(newData) {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await app.post(
      "course/api/client-api/course-content",
      newData,
      config
    );

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to add courses." };
    }
  } catch (error) {
    throw error;
  }
}

export const previewCourseReportPdf = async (options) => {
  return app
    .post(`user/api/client-api/custom-report/preview-pdf`, options, {
      responseType: "blob"
    })
    .then((res) => res.data);
};

export async function downloadCourseReportPdf(options) {
  try {
    const response = await app.post(
      `user/api/client-api/custom-report/download-pdf`,
      options, 
      {
        responseType: "blob",
      });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `course-report-${options.courseId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading course report PDF:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to download course report PDF"
    );
  }
}

export async function downloadCourseReportExcel(options) {
  try {
    const response = await app.post(
      `user/api/client-api/custom-report/download-excel`,
      options,
      {
        responseType: "blob"
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `course-report-${options.courseId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading course report Excel:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to download course report Excel"
    );
  }
}
